import { AlertTriangle, XCircle } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';
import type { Urgency } from './due';

type UrgencyPillProps = {
  readonly urgency: Urgency;
  readonly children: ReactNode;
};

const PILL =
  'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap ring-1 ring-inset';
const TONE = {
  overdue: 'bg-danger/12 text-danger ring-danger/25',
  soon: 'bg-warn/15 text-[color-mix(in_oklch,var(--warn),black_35%)] ring-warn/30 dark:text-warn',
} as const;
const ICONS = { overdue: XCircle, soon: AlertTriangle } as const;

/** Red when late, amber when it is time to act; anything else is information, in plain grey. */
export function UrgencyPill({ urgency, children }: UrgencyPillProps) {
  if (urgency === 'scheduled' || urgency === 'waiting') {
    return <span className="text-xs whitespace-nowrap text-muted-foreground">{children}</span>;
  }
  const Icon = ICONS[urgency];
  return (
    <span className={cn(PILL, TONE[urgency])}>
      <Icon className="size-3" aria-hidden />
      {children}
    </span>
  );
}
